const absoluteUrlRegexp = new RegExp('^(?:[a-z]+:)?//', 'i');

/**
 * Convertie l'url en url absolue
 */
export function normalizeUrl(url: string) {
  return isAbsoluteUrl(url) ? url : `${window.location.protocol}//${window.location.host}${url}`;
}

export function isAbsoluteUrl(url: string) {
  return url ? absoluteUrlRegexp.test(url) : false;
}
